import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  backgroundColorOffCollapse: {
    backgroundColor: `${theme.palette.gray20.main}`,
    borderRadius: "4px",
  },
  backgroundColorOnCollapse: {
    backgroundColor: `${theme.palette.gray20.main}`,
    borderRadius: "unset",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
}));

export default useStyles;
